// extracted by mini-css-extract-plugin
export default {"DataLabelPairing":"DataLabelPairing_DataLabelPairing__yj9Zh","label":"DataLabelPairing_label__Q13FX","data":"DataLabelPairing_data__ElEOI"};